import { Message, Loading } from 'element-ui'
import i18n from './i18n'
// import {getUrl} from '../url'
const pageText = i18n['zh-CN']

// 页面loading
function loadingFn (loadingOptions, pageText) {
  // load 默认配置
  const loadingOptionsDefault = {
    text: pageText.desperatelyLoading,
    background: 'rgba(255, 255, 255, 0.8)',
    spinner: 'el-icon-loading'
  }
  // 通过判断参数类型来区分是否合并参数 字符串：使用默认参数 对象：合并参数
  const isLoadingOptions = typeof loadingOptions === 'object'
  const loading = {
    state: !!loadingOptions,
    instance: null,
    option: isLoadingOptions ? Object.assign(loadingOptionsDefault, loadingOptions) : loadingOptionsDefault,
    hide: function () {
      if (this.state) {
        this.instance.close()
      }
    }
  }
  if (loading.state) {
    loading.instance = Loading(loading.option)
  }
  return loading
}

export default function (promise, option) {
  let optionDefault = {
    authError: true, // 权限错误
    tokeInvalidError: true, // token 无效错误
    showError: true, // 是否处理错误信息
    code: null, // 错误code 对应提示
    loadingOptions: null // loading 配置
  }
  // 合并传入options
  option = typeof option === 'object' ? Object.assign(optionDefault, option) : optionDefault

  let { showError, code, loadingOptions, authError, tokeInvalidError } = option
  const loading = loadingFn(loadingOptions, pageText)

  return promise.then(res => {
    const data = res.data || {}
    const currentPageRequest = data.currentPageRequest
    // 如果不是同一个页面请求 不处理
    if (!currentPageRequest) {
      authError = false
      showError = false
    }

    if (data.code === 'success') {
      data.isOk = true
    } else {
      let handleAuthError = false // 是否处理过权限错误
      data.isOk = false
      // 错误code处理
      let vueInstantiation = window.vueInstantiation // vue 实例
      if (data.code === 'NO_LOGIN') { // 没有登录
        // window.location.href = `#/login?url=${encodeURIComponent(window.location.href)}`
        handleAuthError = true
        showError = false
        vueInstantiation.$store.commit('setUserInfo', { loginStatus: false })
      } else if (data.code === 'NO_PERMISSION') {
        if (authError) {
          handleAuthError = true
          showError = false
          vueInstantiation.$router.replace({ path: '/no-auth' })
        }
      } else if (data.code === 'NO_LEGAL') {
        if (authError) {
          handleAuthError = true
          showError = false
          vueInstantiation.$router.replace({ path: '/no-auth' })
        }
      } else if (data.code === 'INVALID_TOKEN') {
        showError = false
        if (tokeInvalidError) {
          window.location.reload()
        }
      } else if (data.code === '0606060606') {
        // 菜单权限改造 写死 code=0606060606 时不提示接口给的errorMessage
        showError = false
      }

      if (showError && !handleAuthError) {
        if (code && code[data.code]) {
          Message({
            message: code[data.code].message,
            type: 'error'
          })
        } else {
          Message({
            message: data.errorMessage || pageText.networkAbnormalityTryAgain,
            type: 'error'
          })
        }
      }
    }
    // 请求状态 请求发送成功 后端返回异常
    data.requestState = true
    loading.hide && loading.hide()
    return data
  }).catch(function (err) {
    if (err && err.response) {
      const status = {
        400: { message: pageText.requestError },
        401: { message: pageText.unauthorizedPleaseLogIn },
        403: { message: pageText.accessDenied },
        404: { message: pageText.errorRequestAddress },
        408: { message: pageText.requestTimedOut },
        500: { message: pageText.serverInternalError },
        501: { message: pageText.serviceNotImplemented },
        502: { message: pageText.gatewayError },
        503: { message: pageText.serviceIsNotAvailable },
        504: { message: pageText.gatewayTimeout },
        505: { message: pageText.httpVersionNotSupported },
        default: { message: pageText.unknownMistake }
      }
      const statusCode = status[err.response.status] || status.default
      console.log(statusCode.message)
    }
    // if (showError) {
    //   Message({
    //     message: (code && code['DEFAULT'] && code['DEFAULT'].message) || pageText.networkAbnormalityTryAgain,
    //     type: 'error'
    //   })
    // }
    err.isOk = false
    // 请求状态 请求未发送成功
    err.requestFail = false
    // 隐藏loading
    loading.hide && loading.hide()
    return err
  })
}

// 获取响应状态
export function isResponseOk (res) {
  if (!res) {
    Message({
      message: pageText.networkAbnormalityTryAgain,
      type: 'error'
    })
    return
  }
  if (!res.success) {
    Message({
      message: res.errorMessage,
      type: 'error'
    })
    return
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/response/index.js